const noop = () => {};

noop._defaults = {};
export default noop;
//# sourceMappingURL=noop.js.map